<div class="modal-header">
    <h4 class="modal-title">Save {{ type }} as...</h4>
</div>
<div class="modal-body">
    <p>Saving your {{ type }} means you can use it in future quote requests.</p>
    <div class="form-group">
        <input
            legacy-css
            type="text"
            [(ngModel)]="quotePresetDescription"
            placeholder="Type a name..."
            [typeahead]="presetDescriptions"
            typeahead-template-url="default.typeahead.html"
            class="form-control"
            [typeaheadMinLength]="1"
            maxlength="50"
            autofocus />
        <span id="helpBlock" class="help-block">(If you choose an existing name, it will be overwritten)</span>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-o btn-wide" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary btn-o btn-wide" (click)="ok()" [disabled]="!quotePresetDescription">
        Save &amp; Close
    </button>
</div>
